<template>
    <div id="histories-slide">
        <VueSlickCarousel
            class="slider"
            v-bind="settings"
        >
            <div class="slide" v-for="history in slider_data.histories">
                <div class="subtitle-photo" v-text="history.image.title"></div>

                <div class="photo">
                    <picture>
<!--                        <source :srcset="history.image.webp" type="image/webp">-->
                        <source :srcset="history.image.png" type="image/png">
                        <img :src="history.image.png" :alt="history.image.title">
                    </picture>
                </div>

                <div class="content">
                    <div class="title" v-html="history.title"></div>
                    <div class="desc" v-html="history.description"></div>
                    <a :href="history.target" class="btn btn-success" v-text="history.cta"></a>
                </div>
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
    components: { VueSlickCarousel },
    props:{
        slider_data : Object,
        slider_settings: Object,
    },
    data(){
        return{
            currentFilter : '',
            settings: {
                dots:false,
                arrows:true,
                infinite:false,
                speed:0,
                variableWidth:false,
                adaptiveHeight: false,
                draggable: true,
                slidesToShow : 1
            }
        }
    },
    methods:{

    },
    beforeMount() {
        Object.keys(this.slider_settings).forEach((key)=>{
            this.settings[key] = this.slider_settings[key];
        })
    },
}
</script>

<style scoped>

</style>
